import estoreSettings from "../services/estore.settings";
import notification from "../services/notification";
import _ from "lodash";

export default {
    namespaced: true,
    state: {
        loading: false,
        settings: [],
        errors: null,
        brand_categories: [],
        product_categories: [],
        bank_accounts: [],
        payment_type: [],
        fees: [],
        brands: [],
        loyaltyVisibility: null
    },
    mutations: {
        loading(state, value = true) {
            state.loading = value;
        },
        errors(state, errors) {
            state.errors = errors;
            state.loading = false;
        },
        resetErrors(state) {
            state.errors = null;
        },
        settings(state, settings) {
            state.settings = settings;
        },
        brand_categories(state, brand_categories) {
            state.brand_categories = brand_categories;
        },
        product_categories(state, product_categories) {
            state.product_categories = product_categories;
        },
        bank_accounts(state, bank_accounts) {
            state.bank_accounts = bank_accounts;
        },
        payment_type(state, payment_type) {
            state.payment_type = payment_type;
        },
        fees(state, fees) {
            state.fees = fees;
        },
        brands(state, brands) {
            state.brands = brands;
        },
        loyaltyVisibility(state, loyaltyVisibility) {
            state.loyaltyVisibility = loyaltyVisibility;
        }
    },
    actions: {
        async saveFees({ commit }, param) {
            commit("loading");
            try {
                let response = await estoreSettings.saveFees(param);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Oops, cannot save fees.");
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async viewFees({ commit }) {
            commit("errors", null);
            commit("loading");
            try {
                let response = await estoreSettings.viewFees();
                commit("fees", response.list);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Something went wrong");
                commit("loading", false);
            }
        },
        async deleteFees({ commit }, uuid) {
            commit("loading");
            try {
                let response = await estoreSettings.deleteFees(uuid);
                notification.success(response.message);
                // commit("deleted", response);
            } catch (errors) {
                notification.error(errors.message);
                commit("errors", errors);
            }
        },
        async saveSettings({ commit }, param) {
            commit("loading");
            try {
                let response = await estoreSettings.saveSettings(param);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                if (Object.values(errors.errors).indexOf('Brand category name already exist.') > -1) {
                    notification.warning("Brand category name already exist.");
                } else if (Object.values(errors.errors).indexOf('Category name already exist.') > -1) {
                    notification.warning("Category name already exist.");
                } else {
                    notification.warning("Oops, cannot save settings.");
                }
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async viewSettings({ commit }) {
            commit("errors", null);
            commit("loading");
            try {
                let response = await estoreSettings.viewSettings();
                if (response.settings.categories.length > 0) {
                    response.settings.categories.forEach(category => {
                        if (category.sub_categories.length == 0) {
                            category.sub_categories = [
                                {
                                    uuid: "",
                                    name: ""
                                }
                            ];
                        }
                    });
                }

                if (response.settings.categories_enable == "1") {
                    response.settings.categories_enable = true;
                } else {
                    response.settings.categories_enable = false;
                }

                if (response.settings.brand_categories_enable == "1") {
                    response.settings.brand_categories_enable = true;
                } else {
                    response.settings.brand_categories_enable = false;
                }

                if (response.settings.bank_accounts.length === 0) {
                    response.settings.bank_accounts = [
                        {
                            bank: "",
                            account_name: "",
                            account_no: "",
                            uuid: ""
                        }
                    ];
                }

                if (!response.settings.special_discount_enable) {
                    response.settings.special_discount_enable = false
                } else if (response.settings.special_discount_enable == 0){
                    response.settings.special_discount_enable = false
                } else response.settings.special_discount_enable = true;

                if (response.settings.special_discount.length > 0) {
                    if (!response.settings.special_discount[0].channels) {
                        response.settings.special_discount[0].channels = ["sto"]
                    } else if (response.settings.special_discount[0].channels.length == 0 ) {
                        response.settings.special_discount[0].channels = ["sto"]
                    } else  {
                        response.settings.special_discount[0].channels = response.settings.special_discount[0].channels
                    };
                } else {
                    response.settings.special_discount = [{
                        channels: ["sto"],
                        discount_types: [],
                        discount_terms: "",
                        discount_terms_item: ""
                    }]
                }

                commit("settings", response.settings);
                commit(
                    "brand_categories",
                    response.settings.brand_categories.map(obj => {
                        let rBrand = {};
                        rBrand["id"] = obj.uuid;
                        rBrand["name"] = obj.name;
                        return rBrand;
                    })
                );

                commit("payment_type", response.settings.payment_type);
                commit("product_categories", response.settings.categories);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Something went wrong");
                commit("loading", false);
            }
        },
        async getBrands({ commit }) {
            commit("errors", null);
            commit("loading");
            try {
                let response = await estoreSettings.getBrands();
                commit("brands", response);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Something went wrong");
                commit("loading", false);
            }
        },
        async getLoyaltyVisibility({ commit }) {
            commit("errors", null);
            commit("loading");
            try {
                let response = await estoreSettings.getLoyaltyVisibility();
                commit("loyaltyVisibility", response);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Something went wrong");
                commit("loading", false);
            }
        }
    },
    getters: {
        settings: state => state.settings,
        loading: state => state.loading,
        isEnabledPointsEarning: state => _.get(state.settings, "points_earning_enabled", false),
        isEnabledPointsView: state => _.get(state.loyaltyVisibility, "enable_points_view", false)
    }
};
